import { createService } from "@/Services/BaseService";

const RoiQueueGroupService = createService("api/QueueRoiGroup");

export function getQueueGroups(databaseDisplayName) {
  return RoiQueueGroupService.get(`?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`);
}

export function createQueueGroup(databaseDisplayName, name) {
  return RoiQueueGroupService.post(
    `?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`,
    { name }
  );
}

export function renameQueueGroup(databaseDisplayName, id, name) {
  return RoiQueueGroupService.put(
    `/${id}?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`,
    { name }
  );
}

export function deleteQueueGroup(databaseDisplayName, id) {
  return RoiQueueGroupService.delete(
    `/${id}?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`
  );
}

export function setQueueMembership(databaseDisplayName, queueRoiId, groupId) {
  return RoiQueueGroupService.put(
    `/membership?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`,
    { queueRoiId, groupId }
  );
}
